import { filter } from 'util/objects'
import { createSelector } from 'reselect'
import selectByIdIncArchived from './selectByIdIncArchived'

const selectById = createSelector(selectByIdIncArchived, agents => {
  return filter(agent => !agent.archived, agents)
})

export default selectById
